(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertical-thumbnails"]) return;
  try {
    
  (function() {
    const verticalThumbnails = {
      init: function() {
        this.setupThumbnailListeners();
        this.setupVariantListener();
      },
      
      setupThumbnailListeners: function() {
        const thumbnails = document.querySelectorAll('[data-thumbnail-index]');
        if (!thumbnails.length) return;
        
        thumbnails.forEach(thumbnail => {
          thumbnail.addEventListener('click', (e) => {
            e.preventDefault();
            const variantId = thumbnail.getAttribute('data-variant-id');
            const mainImage = thumbnail.getAttribute('data-main-image-src');
            
            // Update main image
            const mainImageElement = document.querySelector('[data-main-image]');
            if (mainImageElement) {
              mainImageElement.src = mainImage;
            }
            
            // Update active thumbnail
            thumbnails.forEach(t => t.classList.remove('active'));
            thumbnail.classList.add('active');
            
            // Update variant if needed
            if (variantId) {
              const variantSelect = document.querySelector('[name="id"]');
              if (variantSelect) {
                variantSelect.value = variantId;
                variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          });
        });
        
        // Set first thumbnail as active
        if (thumbnails.length > 0) {
          thumbnails[0].classList.add('active');
        }
      },
      
      setupVariantListener: function() {
        // Listen for variant changes from swatch
        document.addEventListener('variant-changed', (e) => {
          const variantImages = e.detail.images || [];
          if (variantImages.length > 0) {
            // Update main image
            const mainImageElement = document.querySelector('[data-main-image]');
            if (mainImageElement && variantImages[0]) {
              mainImageElement.src = variantImages[0].src;
            }
            
            // Update thumbnails to show only current variant images
            const thumbnails = document.querySelectorAll('[data-thumbnail-index]');
            thumbnails.forEach(thumbnail => {
              const thumbVariantId = thumbnail.getAttribute('data-variant-id');
              const thumbImageSrc = thumbnail.getAttribute('data-main-image-src');
              
              // Check if this thumbnail belongs to the current variant
              const matchesVariant = variantImages.some(img => img.src === thumbImageSrc);
              
              if (matchesVariant) {
                thumbnail.style.display = 'block';
              } else {
                thumbnail.style.display = 'none';
              }
            });
            
            // Activate first visible thumbnail
            const visibleThumbnails = document.querySelectorAll('[data-thumbnail-index]:not([style*="display: none"])');
            if (visibleThumbnails.length > 0) {
              thumbnails.forEach(t => t.classList.remove('active'));
              visibleThumbnails[0].classList.add('active');
            }
          }
        });
      }
    };
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => verticalThumbnails.init());
    } else {
      verticalThumbnails.init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
